export default [
    {
        path: '/prerequisite/part-qualities',

        name: 'Part Qualities',

        component: () => import('@/views/prerequisite/part-qualities'),
    },
];